import type React from 'react';

import { type Optional } from 'utility-types';

import { Image, type ImageProps } from '../images/Image';

export interface CraftLogoProps extends Optional<Omit<ImageProps, 'aspectRatio'>, 'alt'> {}

export const CraftLogo: React.FC<CraftLogoProps> = props => (
  <Image alt='craft education logo' {...props} aspectRatio={{ height: 78, width: 300 }} />
);
